import { HintTooltip } from '../ui/HintTooltip';
import {
  formatDashboardNumber,
  formatDashboardPercent,
  formatDashboardUsdt,
} from './formatters';
import type { CpDashboardChartsProfile, DashboardCurrency } from '../../api/dashboard';
import { MULTI_LINE_PALETTE } from './DashboardCharts';

function paletteIndex(key: string): number {
  let hash = 0;
  for (let i = 0; i < key.length; i += 1) {
    hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  }
  return hash % MULTI_LINE_PALETTE.length;
}

function formatVolume(value: number, currency: DashboardCurrency): string {
  if (currency === 'usdt') return formatDashboardUsdt(value);
  return formatDashboardNumber(value, currency === 'rub' ? 2 : 0);
}

export function VolumeProfileLegend({
  profiles,
  hiddenIds,
  currency,
  onToggle,
}: {
  profiles: CpDashboardChartsProfile[];
  hiddenIds: number[];
  currency: DashboardCurrency;
  onToggle: (id: number, mode?: 'toggle' | 'solo') => void;
}) {
  const hidden = new Set(hiddenIds);
  return (
    <div className="vnd-scroll hidden w-[11.5rem] shrink-0 flex-col overflow-y-auto sm:flex sm:max-h-[18rem]">
      {profiles.map((profile) => {
        const muted = hidden.has(profile.id);
        const amount = Number(profile.volume?.[currency] ?? 0) || 0;
        const color = MULTI_LINE_PALETTE[paletteIndex(profile.key || `qr:${profile.id}`)];
        return (
          <button
            key={profile.id}
            type="button"
            onClick={(event) => {
              const solo = event.altKey || event.metaKey || event.ctrlKey;
              onToggle(profile.id, solo ? 'solo' : 'toggle');
            }}
            className={`grid w-full grid-cols-[auto_minmax(0,1fr)_auto] items-center gap-x-1 rounded-md px-1 py-1 text-left text-[11px] font-medium transition ${
              muted ? 'text-slate-400 line-through opacity-60' : 'text-slate-700 hover:bg-slate-50 dark:text-gray-200 dark:hover:bg-gray-700'
            }`}
            title={`${profile.name}\n${formatVolume(amount, currency)} ${currency.toUpperCase()}\nКлик — скрыть/показать\n⌥ / Ctrl — только этот`}
          >
            <span
              className="h-2 w-2 shrink-0 rounded-full"
              style={{ backgroundColor: muted ? '#cbd5e1' : color }}
            />
            <span className="min-w-0 truncate">{profile.name}</span>
            <span className="shrink-0 font-mono text-[10px] font-semibold tabular-nums">
              {formatVolume(amount, currency)}
            </span>
          </button>
        );
      })}
    </div>
  );
}

export function WorkloadLegendHelpTip() {
  return (
    <HintTooltip widthClass="w-72">
      <span className="mb-1.5 block text-[10px] font-bold uppercase tracking-wide text-slate-400">
        Легенда графика
      </span>
      <span className="block">Клик — скрыть / показать</span>
      <span className="mt-1.5 block">⌥ Option / Ctrl+клик — оставить только этот</span>
      <span className="mt-1.5 block">⌥ / Ctrl ещё раз по единственному — вернуть все</span>
    </HintTooltip>
  );
}

export { formatDashboardPercent };
